<template>
    <div>
        <FormManager
                @save="save"
                :events="events"
                prettyEndPoint='api/utilities/pretty_data_source_definition_map' />
    </div>
    
</template>

<script>
    export default {
        name: "DataSourceEditorStandard",
        mounted() {
        },
        data() {
            return {
                events: {
                    save: {
                        label: "Add New Data Source (this does not modify an existing source)",
                        event: "save"
                    },
                }
            }
        },
        props: ['extentId'],
        methods: {
            save(values) {
                console.log(values)
                axios.post('/api/dataSources/' + this.extentId, {
                    values: values
                }).then(response => {
                    console.log(response)
                    this.$emit('newDataSource', response.data);
                    console.log('finished saving new data source')
                }).catch(error => {
                    console.log('Could not save new data source')
                    console.log(error.response)
                });
            }
        }
    }
</script>

<style scoped>

</style>